import React from 'react';
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type DateRange = { from: Date; to: Date } | null | undefined;

export interface BreakdownItem {
  id: string;
  name: string;
  impressions: number;
  clicks: number;
  spend: number;
  leads: number;
  ctr: number;
  cpl: number;
}

export function useCampaignBreakdowns(campaignExternalId?: string | null, dateRange?: DateRange) {
  return useQuery({
    queryKey: ["campaign-breakdowns", campaignExternalId, dateRange?.from?.toISOString(), dateRange?.to?.toISOString()],
    queryFn: async () => {
      if (!campaignExternalId) return { adsets: [] as BreakdownItem[], creatives: [] as BreakdownItem[] };
      const start = dateRange?.from ? dateRange.from.toISOString().slice(0, 10) : undefined;
      const end = dateRange?.to ? dateRange.to.toISOString().slice(0, 10) : undefined;
      const { data, error } = await supabase.functions.invoke("facebook-ads-breakdowns", {
        body: { campaignId: campaignExternalId, dateRange: start && end ? { start, end } : undefined },
      });
      if (error) throw error;
      return { adsets: data?.adsets ?? [], creatives: data?.creatives ?? [] } as { adsets: BreakdownItem[]; creatives: BreakdownItem[] };
    },
    enabled: !!campaignExternalId,
  });
}
